require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-tw-s-ig.json") })
        }
      }, "path---photos-professional-tw-s-ig");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-tw-s-ig!./.cache/json/photos-professional-tw-s-ig.json
// module id = 915
// module chunks = 231608221292675